import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpDropdownComponent from './adpDropdown.component';

let adpDropdownModule = angular.module('adpDropdown', [
  uiRouter
])

.component('adpDropdown', adpDropdownComponent)

.name;

export default adpDropdownModule;



// WEBPACK FOOTER //
// ./src/app/components/adpDropdown/adpDropdown.js